// @ts-ignore
import {reactive} from 'vue';

export const store = reactive({
    showLoginDialog: false,
    showUserPrompt: false,
    userPromptTitle: "",
    userPromptContent: "",
    displayNotification: false,
    openSearchDialog: false,
    saUserSession: {
        isAuthenticated: Boolean,
        subscriptionType: "",
        bookmarkedItems: Array<String>(),
        fannedItems: Array<String>(),
        completedQuizItems: Array<String>(),
        location: {}
    },
    profileProgressSection: [
        {
            name: 'Basics',
            url: '/profile-settings/basics',
            tag: 'BasicsCompleted',
            actions: [
                {
                    name: 'Add your display name',
                    tag: 'DisplayNameAdded'
                },
                {
                    name: 'Add an intro',
                    tag: 'IntroductionAdded'
                },
                {
                    name: 'Your occupation',
                    tag: 'OccupationAdded'
                }
            ]
        },
        {
            name: 'Credits',
            url: '/profile-settings/credits',
            tag: 'CreditsCompleted',
            actions: [
                {
                    name: 'Add a credit',
                    tag: 'CreditAdded'
                }
            ]
        },
        {
            name: 'Skills',
            url: '/profile-settings/skills',
            tag: 'SkillsCompleted',
            actions: [
                {
                    name: 'Vocal Part',
                    tag: 'VocalPartAdded'
                },
                {
                    name: 'Dance Skill Level',
                    tag: 'DanceSkillLevelAdded'
                },
                {
                    name: 'Education/ Training',
                    tag: 'EducationalTrainingAdded'
                }
            ]
        },
        {
            name: 'Appearance',
            url: '/profile-settings/appearance',
            tag: 'AppearanceCompleted',
            actions: [
                {
                    name: 'Gender',
                    tag: 'GenderAdded'
                },
                {
                    name: 'Age Range',
                    tag: 'AgeRangeAdded'
                },
                {
                    name: 'Ethnicity',
                    tag: 'EthnicityAdded'
                }
            ]
        },
        {
            name: 'Links',
            url: '/profile-settings/links',
            tag: 'LinksAndRepresentationCompleted',
            actions: [
                {
                    name: 'Profile URL',
                    tag: 'ProfileUrlAdded'
                },
                {
                    name: 'Add a Social Link',
                    tag: 'OutsideLinkAdded'
                }
            ]
        },
        {
            name: 'Headshots',
            url: '/profile-settings/headshots',
            tag: 'HeadshotsCompleted',
            actions: [
                {
                    name: 'Add a Headshot',
                    tag: 'HeadshotAdded'
                }
            ]
        },
        {
            name: 'Resumes',
            url: '/profile-settings/resume',
            tag: 'ResumeCompleted',
            actions: [
                {
                    name: 'Add a Resume',
                    tag: 'ResumeAdded'
                }
            ]
        }
        
    ],
})